import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';


export const mmkvDiscoveryPersistence = new MMKV({
    id: MMKVStoreKeyMap.discoveryStore,
});

export const zustandDiscoveryStore: StateStorage = {
    setItem(name: string, value: string) {
        return mmkvDiscoveryPersistence.set(name, value);
    },
    getItem(name: string) {
        const value = mmkvDiscoveryPersistence.getString(name);
        return value ?? null;
    },
    removeItem(name: string) {
        return mmkvDiscoveryPersistence.delete(name);
    },
};
